import '~/libs/polyfill/register';
import 'react-toastify/dist/ReactToastify.css';

import React, { FC, useMemo } from 'react';
import Helmet from 'react-helmet';
import { Provider } from 'react-redux';

import ToastContainer from '~/components/atoms/ToastContainer';
import { ToastProvider } from '~/components/Layout/ToastContext';
import { LayerProvider } from '~/contexts/LayerContext';
import store from '~/modules';
import LayerWrapper from '~/libs/preBuild/LayerWrapper';
import { NotificationT } from '~/libs/soopI18n';
import FCMRegister from '~/components/organisms/FCMRegister';

const ApplicationWrapper: FC = ({ children }) => {
    const title = useMemo(
        () => `${NotificationT('알림 설정')} - ${'SOOP'}`,
        []
    );
    return (
        <Provider store={store}>
            {/* 헤더 등록 */}
            <Helmet title={title} />
            {/* 알림 서비스 등록 */}
            <FCMRegister />
            <LayerProvider>
                <LayerWrapper />
                <ToastProvider>
                    {children}
                    <ToastContainer />
                </ToastProvider>
            </LayerProvider>
        </Provider>
    );
};

export default ApplicationWrapper;
